<template>
  <div class="fee-analytics d-flex justify-center">
    <apexchart type="pie" width="340" :options="chartOptions" :series="series" :labels="labels"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "StaffAttendanceAnalytics",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    "series" : {
      type: Array
    },
    "labels" : {
      type: Array
    },
    "colors" : {
      type: Array
    },
    "position" : {
      type: String,
      default: 'bottom'
    },
    "width" : {
      type: Number,
      default: 325
    },
    "show" : {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      chartOptions: {
        fill: {
          type: "solid",
          shade: "light",
        },
        chart: {
          id: "staffAttendanceAnalytics"
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: 'red',
            fontSize: '25px',
            fontFamily: 'Montserrat'
          }
        },
        labels: this.labels,
        colors: this.colors,
        series: this.series,
        legend: {
          show: this.show,
          position: this.position,
          width: this.width,
          horizontalAlign: 'center',
          // offsetX: -3,  
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 360,
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
      },
    };
  },

  watch: {
		series : {
			// eslint-disable-next-line no-unused-vars
			async handler(newValue, oldValue) {
				this.chartOptions = {...this.chartOptions, ...{
          series: newValue
				}};
			},
		},
    labels: {
			// eslint-disable-next-line no-unused-vars
      async handler(newValue, oldValue) {
				this.chartOptions = {...this.chartOptions, ...{
          labels: newValue
				}};
			},
    },
    show: {
			// eslint-disable-next-line no-unused-vars
      async handler(newValue, oldValue) {
				this.chartOptions = {...this.chartOptions, ...{
          legend: {
            show: newValue
          }
				}};
			},
    }
	}
};
</script>

<style>
div.apexcharts-legend {
  padding-left: 24px !important;
}

</style>